import { type Configuration, type PopupRequest, LogLevel } from '@azure/msal-browser';
import type { AdminEnv } from '../env';

/**
 * MSAL configuration for the Entra OIDC/PKCE SPA flow. Public client, no secret;
 * tokens live in session storage (cleared when the tab closes) rather than local
 * storage to shrink the XSS exfiltration window.
 */
export function buildMsalConfig(env: AdminEnv): Configuration {
    return {
        auth: {
            clientId: env.entraClientId,
            authority: `https://login.microsoftonline.com/${env.entraTenantId}`,
            redirectUri: env.entraRedirectUri,
            postLogoutRedirectUri: env.entraRedirectUri,
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                logLevel: LogLevel.Warning,
                piiLoggingEnabled: false,
                loggerCallback: () => undefined,
            },
        },
    };
}

/** Interactive login request — asks for the base OIDC scopes + group claims. */
export const loginRequest: PopupRequest = {
    scopes: ['openid', 'profile'],
};

/** Silent token request for the Admin API access token. */
export function adminTokenRequest(env: AdminEnv): { scopes: string[] } {
    return { scopes: [env.adminApiScope] };
}
